export default __webpack_public_path__ + "static/1-62dc10c2c4d13ac83732553141f84ba6.png";